<style type="text/css">

  .SectionTable_row {
    /*display: table-row;*/
    /*border-bottom: 1px solid #e3e3e3;*/
  }

  .SectionTable_column {
    box-sizing: border-box;
    background-color: transparent;
    display: table-cell;
    /*border-left: 1px solid #e3e3e3;*/
    /*border-right: 1px solid #e3e3e3;*/
    padding: 2px 4px;
    font-family: "Carlito";
    font-size: 12px;
    line-height: 1;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
  }

  .SectionTable_column.col-row-header {
    width: 17px;
    min-width: 17px;
    padding-left: 0;
    padding-right: 0;
    background-color: #f5f3f3;
  }

  .SectionTable_column.col-left, .SectionTable_column.col-right {
    width: 9px;
    min-width: 9px;
    max-width: 9px;
    padding-left: 0;
    padding-right: 0;
    @media (min-width: 800px) {
      width: 9px;
      min-width: 9px;
      max-width: 9px;
    }
  }

  .row-worksheet-header > * {
    background-color: #f5f3f3;
    text-align: center;
    color: #555;
    padding: 3px 0 1px;
    padding-right: 0;
    font-size: 10px !important;
  }

  .SectionTable_row.row-section-header
  .SectionTable_column:not(.col-row-header):not(.col-left):not(.col-extra) {
    background-color: #334f77;
    color: #fff;
    font-weight: bold;
  }

  .SectionTable_row.row-section-header
  .SectionTable_column:not(.col-row-header):not(.col-left):not(.col-extra) {
    border-left: 1px solid #334f77;
    border-right: 1px solid #334f77;
  }

  .SectionTable_row.row-section-header.section--disabled
  .SectionTable_column:not(.col-row-header):not(.col-left):not(.col-extra)
  {
    background: #ddd;
    color: #ddd;
    border-left: 1px solid #e3e3e3;
    border-right: 1px solid #e3e3e3;
  }
  .SectionTable_row.row-section-header.section--disabled
  .SectionTable_column.col-content
  {
    color: #636363 !important;
  }

  .SectionTable_row.contentIndent0bold .SectionTable_column {
    font-weight: bold;
  }

  .SectionTable_row.row-section-header .SectionTable_column.units  {
    text-align: center;
  }

  .SectionTable_row.row-subsection-header
  .SectionTable_column:not(.col-row-header):not(.col-left):not(.col-extra) {
    background-color: #ddd;
    color: #000;
  }

  .SectionTable_row.row-resource .col-content {
    font-weight: bold;
    color: navy;
    text-decoration: underline;
    /*width: 230px;*/
    /*min-width: 230px;*/
    /*max-width: 230px;*/
    overflow: initial;
  }

  .SectionTable_row.row-resource.inputIndent0 .col-content {
    color: blue;
    background-color: #fffbce;
  }

  .SectionTable_row.inputIndent1 .col-fcst {
    color: blue;
    background-color: #fffbce;
  }

  .SectionTable_row.inputFcstIndent1 .col-fcst {
    color: blue;
    background-color: #fffbce;
  }
  .SectionTable_row.inputFcstIndent1BoldName .col-content {
    font-weight: bold;
  }
  .SectionTable_row.inputFcstIndent1BoldName .col-fcst {
    color: blue;
    background-color: #fffbce;
  }
  .SectionTable_row.inputFcstIndent1 .col-content {
    padding-left: 15px;
  }

  .SectionTable--section-resource :not(:first-child) .col-content {
    padding-left: 16px;
  }


  .SectionTable.controls {
    position: relative;
    cursor: default;
  }
  .SectionTable.controls:hover {
    background-color: inherit;
  }


  .SectionTable.row-variable .SectionTableRowCell:nth-child(2) {
    padding-left: 20px;
  }

  .SectionTable.section-header {
    background-color: #334f77;
    color: #fff;
  }


  .SectionTable_column.col-header {
    width: 22px;
    background-color: #f5f3f3;
    border-right: 1px solid #ccc;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
  }


  .SectionTable_column.col-content {
    text-align: left;
    overflow: hidden;
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    @media (min-width: 800px) {
      width: 230px;
      min-width: 230px;
      max-width: 230px;
    }
  }


  .row-worksheet-header .SectionTable_column.col-content {
    text-align: center;
  }

  .SectionTable_column.col-units {
    text-align: center;
    width: 40px;
    min-width: 40px;
    max-width: 40px;
    @media (min-width: 800px) {
      width: 60px;
      min-width: 60px;
      max-width: 60px;
    }
  }
  .SectionTable_column.col-zero {
    text-align: center;
    width: 30px;
    min-width: 30px;
    max-width: 30px;
    @media (min-width: 800px) {
      width: 60px;
      min-width: 60px;
      max-width: 60px;
    }
  }

  .SectionTable_column.col-fcst, .SectionTable_column.col-extra {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
    font-size: 12px;
  }

  .SectionTable_column.col-fcst.col-collapsed {
    opacity: 0;
    padding-left: 0;
    padding-right: 0;
    width: 2px;
  }

  .SectionTable_column:nth-child(2) {
    text-align: left;
  }

</style>

<template>

  <div
    class="SectionTable_row"
    :class="row && row.className"
    :style="styles"
  >
    <div
      v-for="(column, i) in rowToShow.columns"
      :key="i"
      class="SectionTable_column"
      :class="column.className"
      v-html="column.content"
    ></div>
  </div>

</template>

<script>

// import TemplateSection from './TemplateSection.vue';

// mixins
import Mixin from '../../../mixins/mixin';

export default {
  components: {
    // TemplateSectionTimeline,
    // TemplateSection,
  },
  mixins: [Mixin],
  props: {
    background: String,
    emptyRow: Boolean,
    row: Object,
    hideExtraColumns: Boolean,
  },
  data: () => ({
    drawer: null,
  }),
  computed: {
    styles() {
      const result = this.background ? `background: ${this.background}` : '';
      return result;
    },
    rowToShow() {
      let row;
      if (this.emptyRow) {
        row = this.getRow({ content: '&nbsp;' });
      } else {
        // eslint-disable-next-line
        if (this.row.content) {
          row = this.getRow(this.row);
        } else {
          row = this.getRow({ content: '&nbsp;' });
          // row = this.row;
        }
      }

      return row;
    },
  },
  methods: {
    getLanguageContent(content) {
      let result = content;
      if (this.$store.state.languages && content && content !== '&nbsp;') {
        // console.log(content);
        const { language } = this.$store.state.activeTemplate;
        // eslint-disable-next-line
        result = this.$store.state.languages[content] && this.$store.state.languages[content][language] || content;
      }

      return result;
    },
    getRow(rowConfig) {
      const { activeTemplate } = this.$store.state;
      let columns;
      let cellCount = 0;

      const {
        id, className, content,
        zeroPeriod,
      } = rowConfig;

      const units = this.translate(rowConfig.units);

      let { fcst } = rowConfig;

      if (!fcst) { fcst = []; }

      if (className === 'row-worksheet-header') {
        // eslint-disable-next-line
        columns = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
      } else if ((className && className.includes('row-subsection-header')) || id === 'periodStart' || id === 'periodEnd' || id === 'daysInPeriod') {
        // generate timeline
        // specify it's midnight so no local timezone affects it
        const firstDateText = `${activeTemplate.data.options.timing.dateStart}T00:00:00`;
        const firstDateObj = new Date(firstDateText);
        // eslint-disable-next-line
        const dateCount = activeTemplate.layout.cFcstColCount;

        let year = firstDateObj.getFullYear();
        let month = firstDateObj.getMonth();
        let day = firstDateObj.getDate();
        let nextDateObj;
        const { periodicity } = activeTemplate.data.options.timing;
        // eslint-disable-next-line
        for (let i = 0; i < dateCount; i++) {
          switch (periodicity) {
            case 'year':
              year += 1;
              break;
            case 'quarter':
              month += 3;
              break;
            case 'month':
              day -= 0;
              month += 1;
              break;
            default:
              //
          }
          const periodEndDateObj = new Date(year, month, day - 1);

          // eslint-disable-next-line
          const periodStartDateObj = new Date(periodicity === 'year' ? year - 1 : year, periodicity === 'quarter' ? month - 3 : (periodicity === 'month' ? month - 1 : month), day);


          nextDateObj = id === 'periodStart' ? periodStartDateObj : periodEndDateObj;
          nextDateObj = this.localizeDate(nextDateObj);
          // eslint-disable-next-line
          const daysInPeriod = Math.round((periodEndDateObj - periodStartDateObj) / (1000 * 60 * 60 * 24)) + 1;

          fcst.push(id === 'daysInPeriod' ? daysInPeriod : nextDateObj);
        }
      } else if (id === 'daysInPeriod') {
        const dateCount = activeTemplate.layout.cFcstColCount;
        // eslint-disable-next-line
        for (let i = 0; i < dateCount; i++) {
          fcst.push('-');
        }
      }

      const result = { columns: [] };
      result.columns.push({ content: '', className: 'col-row-header' });
      // eslint-disable-next-line
      for (let colNum = 0; colNum < activeTemplate.layout.cLeftColCount; colNum++) {
        result.columns.push({
          content: columns && columns[cellCount] ? columns[cellCount] : '',
          className: 'col-left',
        });
        // eslint-disable-next-line
        cellCount++;
      }

      // content
      result.columns.push({
        // eslint-disable-next-line
        content: columns && columns[cellCount] ? columns[cellCount] : this.getLanguageContent(content),
        className: 'col-content',
      });
      // eslint-disable-next-line
      cellCount++;

      // empty cells on right
      // eslint-disable-next-line
      for (let colNum = 0; colNum < activeTemplate.layout.cRightColCount; colNum++) {
        result.columns.push({
          content: columns && columns[cellCount] ? columns[cellCount] : '',
          className: 'col-right',
        });
        // eslint-disable-next-line
        cellCount++;
      }

      // units
      result.columns.push({
        // eslint-disable-next-line
        content: columns && columns[cellCount] ? columns[cellCount] : (units ? units : ''),
        className: 'col-units',
      });
      // eslint-disable-next-line
      cellCount++;

      // zero period
      if (className === 'row-section-header') {
        result.columns.push({
          // eslint-disable-next-line
          content: columns && columns[cellCount] ? columns[cellCount] : (zeroPeriod ? zeroPeriod : ''),
          className: 'col-zero',
        });
      } else {
        result.columns.push({
          // eslint-disable-next-line
          content: columns && columns[cellCount] ? columns[cellCount] : (zeroPeriod ? zeroPeriod : ''),
          className: 'col-zero',
        });
      }

      // eslint-disable-next-line
      cellCount++;

      const cFcstColCount = parseInt(activeTemplate.layout.cFcstColCount, 0);

      // max 20 fcst cols
      // this.hideExtraColumns = true;
      const cFcstColCountExtraCols = Math.min(cFcstColCount, 15);
      // const cFcstColCountExtraCols = Math.min(cFcstColCount + (this.hideExtraColumns ? 0 : 5), 10);

      // hist / fcst cells
      // eslint-disable-next-line
      for (let colNum = 0; colNum < cFcstColCountExtraCols; colNum++) {
        // eslint-disable-next-line
        let content = '';
        if (columns && columns[cellCount]) {
          content = columns[cellCount];
        } else if (fcst && typeof fcst[colNum] !== 'undefined') {
          // format number, same as in the store
          const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          // eslint-disable-next-line
          content = !isNaN(fcst[colNum]) ? formatter.format(fcst[colNum]) : fcst[colNum]; // String(fcst[colNum]).match(/\D/g) ? fcst[colNum] : new Intl.NumberFormat().format(fcst[colNum]);
        }
        result.columns.push({
          content,
          className: colNum < cFcstColCount ? 'col-fcst' : 'col-extra',
        });
        // eslint-disable-next-line
        cellCount++;
      }

      if (className) {
        result.className = className;
      }
      return result;
    },
  },
  mounted() {},
};
</script>
